.a6{justify-content:center;}